import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "homepage" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("French")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Chinese")

import AppLayout from '@/components/layout/AppLayout.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(AppLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", null, [
          _createVNode(_component_router_link, { to: "/french" }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _createElementVNode("p", null, [
          _createVNode(_component_router_link, { to: "/chinese" }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }))
}
}

})